import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";

import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import { api } from "../../../../../utils";
import { IError } from "../../../../../models/ReportPageModels";
import { PaginationModel } from "../../../../../models/ReportGridModels";
import { renderCellExpand } from "../../../../Billing/Billing/renderCellExpand";

const columns = [
    { field: 'id', headerName: 'ID', width: 10 },
    { field: 'productCode', headerName: 'Product Code', width: 200 },
    {
        field: 'description', headerName: 'Description', width: 800,
        renderCell: renderCellExpand
    },
    { field: 'billingPer', headerName: 'Billing Per', width: 200 },
    { field: 'unitPrice', headerName: 'Unit Price', width: 200 },
];
const columnVisibility = {
    id: false
}

interface ProductModel {
    id: number,
    productCode: string;
    description: string;
    billingPer: string;
    unitPrice: number;
}

interface ProductsResponse {
    data: ProductsData;
    error: IError;
}
interface ProductsData {
    products: ProductModel[];
}

const headerHeight: number = 112;

function PricingProducts() {
    const { enqueueSnackbar } = useSnackbar();

    const [products, setProducts] = useState<ProductModel[]>([]);

    const [paginationModel, setPaginationModel] = useState<PaginationModel>({
        pageSize: 50,
        page: 0,
    });

    useEffect(() => {
        GetProducts();
    }, []);

    const GetProducts = async () => {
        try {
            const response: ProductsResponse = await api.get("api/Admin/GetProducts", {
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (response.error == null) {
                setProducts(response.data.products);
            }
            else {
                enqueueSnackbar(response.error.description, { variant: "error" });
            }
        }
        catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    }

    function GetGridHeight() {
        return window.innerHeight - headerHeight;
    }

    return (
        <DataGrid
            sx={{ height: GetGridHeight() }}
            rows={products}
            columns={columns}
            columnVisibilityModel={columnVisibility}
            pagination
            pageSizeOptions={[10, 15, 20, 50, 100]}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            slots={{ toolbar: GridToolbar }}
            slotProps={{
                toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 100 },
                },
            }} />
    )
}

export default PricingProducts;